export const getTimeSpent = (startDate) => {
    const startDay = new Date(startDate)
    const today = new Date()
    let timeSpent;
    let months = (today.getFullYear() - startDay.getFullYear()) * 12
    months -= startDay.getMonth()
    months += today.getMonth()
    timeSpent = months <= 0 ? 0 : months;
    return timeSpent
}